import React, { Component } from 'react'
import EstimationStore from '../../../libs/EstimationStore'
import EstimationActions from '../../../libs/EstimationActions'
import Utils from '../../../libs/Utils'
import OneLineEditor from '../../../components/OneLineEditor'
import OneLineEditorWithSuggestion from '../../../components/OneLineEditorWithSuggestion'
import CheckBox from '../../../components/CheckBox'
import Config from '../../../../Config'

import Window from '../../../../common/Window'

class LaborCostTab extends Component {
  constructor (props) {
    super(props)
    this.state = {
      data: EstimationActions.getCurrentEstimation(),
      listener: null
    }
  }
  componentDidMount () {
    this.setState({
      listener: EstimationStore.addListener('change', () => {
        this.setState({
          data: EstimationActions.getCurrentEstimation()
        })
      })
    })
  }
  componentWillUnmount () {
    if (this.state.listener) this.state.listener.remove()
  }
  onInsert (offset, e) {
    EstimationActions.insertUchiwake(offset)
  }
  onDelete (offset, e) {
    if (this.state.data.uchiwakeList.length > 1) {
      Window.confirm('この行を削除してもよろしいですか?', () => {
        EstimationActions.deleteUchiwake(offset)
        Window.closeDialog()
      })
    }
  }
  onMoveUp (offset, e) {
    if (offset > 0) {
      EstimationActions.moveUpUchiwake(offset)
    }
  }
  onMoveDown (offset, e) {
    if (offset < this.state.data.uchiwakeList.length - 1) {
      EstimationActions.moveDownUchiwake(offset)
    }
  }
  render () {
    var uchiwakeList = []
    var data = this.state.data.uchiwakeList
    let katawakuSuuryou = 0
    let daikuKingakuGoukei = 0
    let daikuNinkuGoukei = 0

    const nameOptions = Config.estimation.nameOptions
    const unitOptions = Config.estimation.unitOptions

    const daikuLabor = EstimationActions.getLaborSharedValues('daiku')
    let daikuLaborUnitPrice = daikuLabor.laborUnitPrice
    let daikuHoninHutanUnitPirce = daikuLabor.honninDailyHokenRyou
    let daikuKoyounushiHutanUnitPrice = daikuLabor.koyonushiDailyHokenRyou
    const kaitaiLabor = EstimationActions.getLaborSharedValues('kaitai')
    let kaitaiLaborUnitPrice = kaitaiLabor.laborUnitPrice
    let kaitaiHoninHutanUnitPirce = kaitaiLabor.honninDailyHokenRyou
    let kaitaiKoyounushiHutanUnitPrice = kaitaiLabor.koyonushiDailyHokenRyou

    let kaitaiKingakuGoukei = 0
    let kaitaiNinkuGoukei = 0

    for (let i = 0; i < data.length; i++) {
      if (data[i].isKatawakuSuuryou) {
        katawakuSuuryou += data[i].suuryou ? parseFloat(data[i].suuryou) : 0
      }
      let daikuNinku = data[i].daikuNinku ? data[i].daikuNinku : 0
      daikuKingakuGoukei += Math.round(daikuNinku * daikuLaborUnitPrice)
      daikuNinkuGoukei += parseFloat(daikuNinku)

      let kaitaiNinku = data[i].kaitaiNinku ? data[i].kaitaiNinku : 0
      kaitaiKingakuGoukei += Math.round(kaitaiNinku * kaitaiLaborUnitPrice)
      kaitaiNinkuGoukei += parseFloat(kaitaiNinku)
      const kwLast = (i === data.length - 1) ? 'kw-bottom-double ' : ''
      uchiwakeList.push(
        <tr style={{borderTop: (i === 0) ? '3px double black' : ''}} key={i}>
          <td className={kwLast + 'text-left kw-inputable'}><OneLineEditorWithSuggestion options={nameOptions} isList listName='uchiwakeList' index={i} bindingDataAttribute='name' /></td>
          <td className={kwLast + 'kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='specification' /></td>
          <td className={kwLast + 'text-right kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='suuryou' isNum textAlign='right' decimalPlaces='1' callback={EstimationActions.updateBothNinku} /></td>
          <td className={kwLast + 'text-center kw-inputable'}><OneLineEditorWithSuggestion options={unitOptions} isList listName='uchiwakeList' index={i} bindingDataAttribute='tani' textAlign='center' /></td>
          <td className={kwLast + 'text-center'}><CheckBox isList listName='uchiwakeList' index={i} bindingDataAttribute='isKatawakuSuuryou' /></td>
          <td className={kwLast + 'text-center kw-gyou-sousa-icons'}>
            <span className='text-success'><i className='icon-plus-sign' style={{cursor: 'pointer'}} onClick={(e) => this.onInsert(i, e)} /></span>
            <span className='text-error'><i className='icon-minus-sign' onClick={(e) => this.onDelete(i, e)}
              style={data.length <= 1 ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(185, 74, 72)', cursor: 'pointer'}} /></span>
            <span className='text-info'><i className='icon-circle-arrow-up' style={i === 0 ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={(e) => this.onMoveUp(i, e)} /></span>
            <span className='text-info'><i className='icon-circle-arrow-down' style={i === data.length - 1 ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={(e) => this.onMoveDown(i, e)} /></span>
          </td>
          <td className={kwLast + 'text-right kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='daikuBugakari' isNum decimalPlaces='1' callback={EstimationActions.updateNinku} textAlign='right' /></td>
          <td className={kwLast + 'text-right kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='daikuNinku' isNum decimalPlaces='1' callback={EstimationActions.updateBugakari} textAlign='right' /></td>
          <td className={kwLast + 'text-right'}>{Utils.convKingaku(daikuLaborUnitPrice)}</td>
          <td className={kwLast + 'text-right'}>{Utils.convKingaku(daikuLaborUnitPrice * daikuNinku)}</td>
          <td className={kwLast + 'text-right'}>{Utils.convKingaku(daikuLaborUnitPrice * daikuNinku / data[i].suuryou, 1)}</td>
          <td className={kwLast + 'text-right kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='kaitaiBugakari' isNum decimalPlaces='1' callback={EstimationActions.updateNinku} textAlign='right' /></td>
          <td className={kwLast + 'text-right kw-inputable'}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='kaitaiNinku' isNum decimalPlaces='1' callback={EstimationActions.updateBugakari} textAlign='right' /></td>
          <td className={kwLast + 'text-right'}>{Utils.convKingaku(kaitaiLaborUnitPrice)}</td>
          <td className={kwLast + 'text-right'}>{Utils.convKingaku(kaitaiLaborUnitPrice * kaitaiNinku)}</td>
          <td className={kwLast + 'text-right'}>{Utils.convKingaku(kaitaiLaborUnitPrice * kaitaiNinku / data[i].suuryou, 1)}</td>
          <td className={kwLast + 'text-right'}>{Utils.convKingaku(daikuLaborUnitPrice * daikuNinku + kaitaiLaborUnitPrice * kaitaiNinku)}</td>
          <td className={kwLast + 'text-right'}>{Utils.convKingaku((daikuLaborUnitPrice * daikuNinku + kaitaiLaborUnitPrice * kaitaiNinku) / data[i].suuryou)}</td>
        </tr>
      )
    }
    return (
      <div>
        <article className='kw-katawaku-art'>

          <div className='kw-laborview'>

            <h4>労務費の計算</h4>

            <table>
              <thead>
                <tr>
                  <th className='kw-name' />
                  <th className='kw-specific' />
                  <th className='kw-person' />
                  <th className='kw-unit' />

                  <th className='kw-katawaku-suuryou-hanei' />
                  <th className='kw-gyou-sousa' />
                  <th className='kw-bugakari' />
                  <th className='kw-ninku' />
                  <th className='kw-yen-unit-price' />
                  <th className='kw-yen1' />
                  <th className='kw-person-unit-price' />

                  <th className='kw-bugakari' />
                  <th className='kw-ninku' />
                  <th className='kw-yen-unit-price' />
                  <th className='kw-yen1' />
                  <th className='kw-person-unit-price' />

                  <th className='kw-yen1' />
                  <th className='kw-person-unit-price' />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th colSpan='5'>内訳項目(共通)</th>
                  <th rowSpan='3'>
                    <span className='text-success'><i className='icon-plus-sign'>挿入</i></span><br />
                    <span className='text-error'><i className='icon-minus-sign'>削除</i></span><br />
                    <span className='text-info'><i className='icon-circle-arrow-up'>上へ</i></span><br />
                    <span className='text-info'><i className='icon-circle-arrow-down'>下へ</i></span>
                  </th>
                  <th colSpan='5'>型枠大工</th>
                  <th colSpan='5'>型枠解体工</th>
                  <th colSpan='2'>人件費</th>
                </tr>
                <tr>
                  <th className='kw-th-meisyo' rowSpan='2'>名称</th>
                  <th rowSpan='2'>仕様</th>
                  <th rowSpan='2'>数量</th>
                  <th rowSpan='2'>単位</th>

                  <th rowSpan='2'>型枠<br />数量<br />反映</th>

                  <th>歩掛</th>
                  <th>人工</th>
                  <th>人件費</th>
                  <th>金額</th>
                  <th>単価</th>

                  <th>歩掛</th>
                  <th>人工</th>
                  <th>人件費</th>
                  <th>金額</th>
                  <th>㎡単価</th>

                  <th>合計金額</th>
                  <th>単価</th>
                </tr>
                <tr>
                  <th>数量/人</th>
                  <th>人</th>
                  <th>円/人</th>
                  <th>円</th>
                  <th>円/数量</th>

                  <th>数量/人</th>
                  <th>人</th>
                  <th>円/人</th>
                  <th>円</th>
                  <th>円/数量</th>

                  <th>円</th>
                  <th>円/数量</th>
                </tr>
                {uchiwakeList}
                <tr>

                  <td className='kw-top-double text-left'>合計</td>
                  <td className='kw-top-double' />
                  <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
                  <td className='kw-top-double kw-ln' />
                  <td className='kw-top-double text-center kw-ln' />

                  <td className='kw-top-double text-center kw-ln' />

                  <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou / daikuNinkuGoukei, 1)}</td>
                  <td className='kw-top-double text-right'>{Utils.convSuuryou(daikuNinkuGoukei, 1)}</td>
                  <td className='kw-top-double kw-ln' />
                  <td className='kw-top-double text-right'>{Utils.convKingaku(daikuKingakuGoukei)}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku(daikuKingakuGoukei / katawakuSuuryou, 1)}</td>

                  <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou / kaitaiNinkuGoukei, 1)}</td>
                  <td className='kw-top-double text-right'>{Utils.convSuuryou(kaitaiNinkuGoukei, 1)}</td>
                  <td className='kw-top-double kw-ln' />
                  <td className='kw-top-double text-right'>{Utils.convKingaku(kaitaiKingakuGoukei)}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku(kaitaiKingakuGoukei / katawakuSuuryou, 1)}</td>

                  <td className='kw-top-double text-right'>{Utils.convKingaku(daikuKingakuGoukei + kaitaiKingakuGoukei)}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku((daikuKingakuGoukei + kaitaiKingakuGoukei) / katawakuSuuryou)}</td>
                </tr>
              </tbody>
            </table>

            <h4>社会保険料(本人負担分)の計算</h4>

            <table>
              <thead>
                <tr>
                  <th className='kw-name' />
                  <th className='kw-specific' />
                  <th className='kw-person' />
                  <th className='kw-unit' />

                  <th className='kw-katawaku-suuryou-hanei' />
                  <th className='kw-gyou-sousa' />

                  <th className='kw-bugakari' />
                  <th className='kw-ninku' />
                  <th className='kw-yen-unit-price' />
                  <th className='kw-yen1' />
                  <th className='kw-person-unit-price' />

                  <th className='kw-bugakari' />
                  <th className='kw-ninku' />
                  <th className='kw-yen-unit-price' />
                  <th className='kw-yen1' />
                  <th className='kw-person-unit-price' />

                  <th className='kw-yen1' />
                  <th className='kw-person-unit-price' />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th colSpan='6' />
                  <th colSpan='5'>型枠大工</th>
                  <th colSpan='5'>型枠解体工</th>
                  <th colSpan='2'>人件費</th>
                </tr>
                <tr>
                  <th className='kw-th-meisyo kw-bottom-double' rowSpan='2'>名称</th>
                  <th className='kw-bottom-double' rowSpan='2' />
                  <th>数量</th>
                  <th />

                  <th />
                  <th className='kw-bottom-double' rowSpan='2' />

                  <th className='kw-ln' />
                  <th>人工</th>
                  <th>単価</th>
                  <th>金額</th>
                  <th>㎡単価</th>

                  <th className='kw-ln' />
                  <th>人工</th>
                  <th>単価</th>
                  <th>金額</th>
                  <th>㎡単価</th>

                  <th>金額</th>
                  <th>㎡単価</th>
                </tr>
                <tr>
                  <th className='kw-bottom-double'>㎡</th>
                  <th className='kw-bottom-double' />

                  <th className='kw-bottom-double' />

                  <th className='kw-ln kw-bottom-double' />
                  <th className='kw-bottom-double'>人</th>
                  <th className='kw-bottom-double'>円/人</th>
                  <th className='kw-bottom-double'>円</th>
                  <th className='kw-bottom-double'>円/㎡</th>

                  <th className='kw-ln kw-bottom-double' />
                  <th className='kw-bottom-double'>人</th>
                  <th className='kw-bottom-double'>円/人</th>
                  <th className='kw-bottom-double'>円</th>
                  <th className='kw-bottom-double'>円/㎡</th>

                  <th className='kw-bottom-double'>円</th>
                  <th className='kw-bottom-double'>円/㎡</th>
                </tr>
                <tr>
                  <td className='kw-top-double'>全体</td>
                  <td className='kw-top-double' />
                  <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
                  <td className='kw-top-double text-center' />
                  <td className='kw-top-double text-center' />
                  <td className='kw-top-double kw-ln' />
                  <td className='kw-top-double kw-ln' />
                  <td className='kw-top-double text-right'>{Utils.convSuuryou(daikuNinkuGoukei, 1)}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku(daikuHoninHutanUnitPirce)}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku(Number(daikuHoninHutanUnitPirce).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1))}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku((Number(daikuHoninHutanUnitPirce).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1)) / katawakuSuuryou, 1)}</td>

                  <td className='kw-top-double kw-ln' />
                  <td className='kw-top-double text-right'>{Utils.convSuuryou(kaitaiNinkuGoukei, 1)}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku(kaitaiHoninHutanUnitPirce)}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku(Number(kaitaiHoninHutanUnitPirce).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1))}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku((Number(kaitaiHoninHutanUnitPirce).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1)) / katawakuSuuryou, 1)}</td>

                  <td className='kw-top-double text-right'>{Utils.convKingaku(Number(daikuHoninHutanUnitPirce).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1) + Number(kaitaiHoninHutanUnitPirce).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1))}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku((Number(daikuHoninHutanUnitPirce).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1) + Number(kaitaiHoninHutanUnitPirce).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1)) / katawakuSuuryou)}</td>
                </tr>
              </tbody>
            </table>

            <h4>法定福利費の計算</h4>

            <table>
              <thead>
                <tr>
                  <th className='kw-name' />
                  <th className='kw-specific' />
                  <th className='kw-person' />
                  <th className='kw-unit' />

                  <th className='kw-katawaku-suuryou-hanei' />
                  <th className='kw-gyou-sousa' />
                  <th className='kw-bugakari' />
                  <th className='kw-ninku' />
                  <th className='kw-yen-unit-price' />
                  <th className='kw-yen1' />
                  <th className='kw-person-unit-price' />

                  <th className='kw-bugakari' />
                  <th className='kw-ninku' />
                  <th className='kw-yen-unit-price' />
                  <th className='kw-yen1' />
                  <th className='kw-person-unit-price' />

                  <th className='kw-yen1' />
                  <th className='kw-person-unit-price' />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th colSpan='6' />
                  <th colSpan='5'>型枠大工</th>
                  <th colSpan='5'>型枠解体工</th>
                  <th colSpan='2'>人件費</th>
                </tr>
                <tr>
                  <th className='kw-th-meisyo kw-bottom-double' rowSpan='2'>名称</th>
                  <th className='kw-bottom-double' rowSpan='2' />
                  <th>数量</th>
                  <th />

                  <th />
                  <th className='kw-bottom-double' rowSpan='2' />
                  <th className='kw-ln' />
                  <th>人工</th>
                  <th>単価</th>
                  <th>金額</th>
                  <th>㎡単価</th>

                  <th className='kw-ln' />
                  <th>人工</th>
                  <th>単価</th>
                  <th>金額</th>
                  <th>㎡単価</th>

                  <th>金額</th>
                  <th>㎡単価</th>
                </tr>
                <tr>
                  <th className='kw-bottom-double'>㎡</th>
                  <th className='kw-bottom-double' />

                  <th className='kw-bottom-double' />

                  <th className='kw-ln kw-bottom-double' />
                  <th className='kw-bottom-double'>人</th>
                  <th className='kw-bottom-double'>円/人</th>
                  <th className='kw-bottom-double'>円</th>
                  <th className='kw-bottom-double'>円/㎡</th>

                  <th className='kw-ln kw-bottom-double' />
                  <th className='kw-bottom-double'>人</th>
                  <th className='kw-bottom-double'>円/人</th>
                  <th className='kw-bottom-double'>円</th>
                  <th className='kw-bottom-double'>円/㎡</th>

                  <th className='kw-bottom-double'>円</th>
                  <th className='kw-bottom-double'>円/㎡</th>
                </tr>
                <tr>
                  <td className='kw-top-double'>全体</td>
                  <td className='kw-top-double' />
                  <td className='kw-top-double text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
                  <td className='kw-top-double text-center' />

                  <td className='kw-top-double text-center' />
                  <td className='kw-top-double kw-ln' />
                  <td className='kw-top-double kw-ln' />
                  <td className='kw-top-double text-right'>{Utils.convSuuryou(daikuNinkuGoukei, 1)}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku(daikuKoyounushiHutanUnitPrice)}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku(Number(daikuKoyounushiHutanUnitPrice).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1))}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku((Number(daikuKoyounushiHutanUnitPrice).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1)) / katawakuSuuryou, 1)}</td>

                  <td className='kw-top-double kw-ln' />
                  <td className='kw-top-double text-right'>{Utils.convSuuryou(kaitaiNinkuGoukei, 1)}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku(kaitaiKoyounushiHutanUnitPrice)}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku(Number(kaitaiKoyounushiHutanUnitPrice).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1))}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku((Number(kaitaiKoyounushiHutanUnitPrice).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1)) / katawakuSuuryou, 1)}</td>

                  <td className='kw-top-double text-right'>{Utils.convKingaku(Number(daikuKoyounushiHutanUnitPrice).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1) + Number(kaitaiKoyounushiHutanUnitPrice).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1))}</td>
                  <td className='kw-top-double text-right'>{Utils.convKingaku((Number(daikuKoyounushiHutanUnitPrice).toFixed(0) * Number(daikuNinkuGoukei).toFixed(1) + Number(kaitaiKoyounushiHutanUnitPrice).toFixed(0) * Number(kaitaiNinkuGoukei).toFixed(1)) / katawakuSuuryou)}</td>
                </tr>
              </tbody>
            </table>

          </div>
        </article>
      </div>
    )
  }
}

export default LaborCostTab



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationEdit/LaborCostTab.js